import { apiDelete, apiGet, apiPut, API_URI } from 'api';

const notification = {
    getAll: async () => {
        const data = apiGet(`${API_URI}/api/notification`); 
        return data;
    },
    get: async (id: number) => {
        const data = await apiGet(`${API_URI}/api/notification/${id}`);
        return data;
    },
    markAsSeen: async (id: number) => {
        const data = await apiPut(`${API_URI}/api/notification/${id}/seen`);
        return data;
    },
    markAllAsSeen: async () => {
        const data = await apiPut(`${API_URI}/api/notification/seen`);
        return data;
    },
    delete: async (id: number) => {
        const data = await apiDelete(`${API_URI}/api/notification/${id}`);
        return data;
    }
}

export default notification;